"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEApplication = void 0;
var AEApplication;
(function (AEApplication) {
    AEApplication[AEApplication["satz"] = 0] = "satz";
    AEApplication[AEApplication["mitnehmer"] = 1] = "mitnehmer";
    AEApplication[AEApplication["festpunkt"] = 2] = "festpunkt";
})(AEApplication = exports.AEApplication || (exports.AEApplication = {}));
//# sourceMappingURL=AEApplication.js.map